import { render, staticRenderFns } from "./MainLedgerDetailIndex.vue?vue&type=template&id=5e7b81b4&scoped=true"
import script from "./MainLedgerDetailIndex.vue?vue&type=script&lang=js"
export * from "./MainLedgerDetailIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7b81b4",
  null
  
)

export default component.exports